<ng-container [ngSwitch]="data.campoId">
    <app-salfa-info-tag *ngSwitchCase="DIALOG_KEYS.DEUDA_TAG"></app-salfa-info-tag>

    <div mat-dialog-actions align="end">
        <button mat-button [mat-dialog-close]="true">Cerrar</button>
    </div>
</ng-container>
